import axios from "axios";

export function postUserLogs({ payload }) {
  return axios.post(
    `https://9n837gy1ne.execute-api.ap-southeast-1.amazonaws.com/staging/elasticattractor/query/`,
    payload
  );
}
